import createTheme from '@sift/skipper/styles/createTheme';
import colors from './colors';
import typography from './typography';

const spacing = [0, 8, 16, 24, 32, 40];

export default createTheme({
  accountStatus: {
    activeColor: '#5fc36b',
    suspendedColor: '#ff586d',
    invitedColor: '#ff930a',
    notInvitedStatus: '#47289e',
    deletedStatus: '#000',
  },
  typography,
  overrides: {
    AppSidebar: {
      width: 258,
    },
    AppHeader: {
      minHeight: spacing[7],
      maxHeight: spacing[7],
    },
    MuiButton: {
      root: {
        ...typography.button,
      },
    },
    MuiCard: {
      root: {
        marginBottom: spacing[3],
      },
    },
    MuiCardActionArea: {
      root: {
        padding: spacing[0],
      },
    },
    MuiCardHeader: {
      title: {
        ...typography.h5,
      },
      subheader: typography.subtitle2,
      root: {
        padding: `${spacing[3]}px`,
      },
    },
    MuiCardContent: {
      root: {
        padding: `${spacing[2]}px ${spacing[3]}px ${spacing[3]}px ${spacing[3]}px`,
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: '0px 2px 4px rgba(33, 33, 33, 0.07)',
      },
      elevation2: {
        boxShadow: '0px 4px 6px rgba(33, 33, 33, 0.07), 0px 8px 8px -4px rgba(33, 33, 33, 0.05)',
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 12,
      },
    },
    MuiTabs: {
      indicator: {
        backgroundColor: colors.secondary,
      },
      root: {
        marginBottom: spacing[2],
      },
    },
    MuiTab: {
      root: {
        '&$selected': {
          color: colors.secondary,
        },
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: colors.divider,
        marginLeft: spacing[3],
        marginRight: spacing[3],
      },
    },
    MuiDialogActions: {
      root: {
        padding: '24px',
      },
    },
    MuiDialogContent: {
      root: {
        padding: '0 24px',
        paddingTop: '24px',
      },
    },
    MuiDialogContentText: {
      root: {
        marginBottom: 0,
        ...typography.subtitle2,
        color: colors.gray1,
      },
    },
    MuiDialogTitle: {
      root: {
        '& h2': {
          ...typography.h5,
        },
        padding: '24px',
        paddingBottom: 0,
        '& span': {
          display: 'block',
          ...typography.body1,
        },
      },
    },
  },
  palette: {
    primary: {
      main: colors.primary,
      light: colors.lightPrimary,
      dark: colors.darkPrimary,
    },
    secondary: {
      main: colors.secondary,
      light: colors.lightSecondary,
      dark: colors.darkSecondary,
    },
    error: {
      main: colors.error,
    },
    warning: {
      main: colors.warning,
    },
    info: {
      main: colors.info,
    },
    success: {
      main: colors.success,
    },
    text: {
      primary: colors.primaryText,
      secondary: colors.gray1,
    },
    opacity: {
      fourPercent: 0.04,
      eightPercent: 0.08,
      twelvePercent: 0.12,
      thirtyEightPercent: 0.38,
    },
  },
  colors,
});
